<template>
  <b-card title="Opieka Serwisowa" class="title-inline">
    <b-card-text>
      <b-row>
        <b-col xl="8">
          <p class="mt-3"><strong>Drogi Użytkowniku,</strong></p>
          <p>
            Przed nami nowy rok kalendarzowy. Mamy nadzieję, że będzie to
            kolejny rok naszej współpracy.
          </p>
          <p>
            W tym miejscu, od 1 stycznia {{ year }} roku, pojawi się formularz
            zamówienia na Aktualizację i Opiekę Serwisową {{ year }}.<br />
            Jednocześnie zachęcamy do rozbudowy swojego
            {{ program.toUpperCase() }}<sup>®</sup> o praktyczne moduły i
            dodatki.
            <!--            <a-->
            <!--              href="https://www.ksiega-podatkowa.pl/konfigurator"-->
            <!--              target="_blank"-->
            <!--            >-->
            <!--              Zobacz Konfigurator {{ program.toUpperCase() }}<sup>®</sup>-->
            <!--            </a>-->
            <!--            i sprawdź, które z nich mogą usprawnić księgowanie w Twojej firmie.-->
          </p>
          <div>
            <div v-if="price" class="mx-5">
              <p>Twój obecny pakiet zawiera następujące produkty:</p>
              <div v-for="(item, index) in products" :key="index">
                <span>
                  <img :src="styles.check" alt="check" class="mb-1" />
                  {{ item }}
                </span>
              </div>
              <p class="font-weight-bold mt-2">
                Koszt Opieki Serwisowej w roku {{ year }} wyniesie:
                <span class="text-info">{{ price }} zł</span>
              </p>
            </div>
          </div>
          <p>
            W międzyczasie przeczytaj, jakie zmiany przygotujemy dla Ciebie w
            kolejnych wersjach programu. Kliknij
            <router-link :to="{ name: 'NewYear' }">
              <strong>Co z nowym rokiem</strong>
            </router-link>
            .<br />
            Zachęcamy również do sprawdzenia i uzupełnienia danych licencyjnych
            oraz kontaktowych.
          </p>
          <p class="text-right">Zapraszamy od 1 stycznia {{ year }} r.</p>
          <p class="text-right">Zespół FORMSOFT</p>
        </b-col>
      </b-row>
    </b-card-text>
  </b-card>
</template>
<script>
import { mapGetters } from 'vuex';
import { adds } from '../../config/adds';
import { modules } from '../../config/modules';

export default {
  name: 'BlockOrder',
  props: {
    styles: {},
  },
  data() {
    return {
      year: process.env.MIX_AKTU_YEAR,
      price: null,
      error: null,
    };
  },
  computed: {
    ...mapGetters({
      client: 'auth/client',
      program: 'getProgram',
      licence: 'auth/userLicence',
    }),
    programFormatMark() {
      return this.program === 'skp' ? 'SkpClient' : 'SamClient';
    },
    products() {
      let that = this;
      let all = [];

      if (this.client.MDS.includes('B')) {
        if (this.client.B_level === 3) {
          all.push('Biuro: bez limitu firm');
        } else if (this.client.B_level === 2) {
          all.push('Biuro: do 50 firm');
        } else if (this.client.B_level === 1) {
          all.push('Biuro: do 10 firm');
        } else {
          all.push('Biuro');
        }
      } else {
        all.push('SKP Firma');
      }
      if (this.client && this.client.DOD !== null && this.client.DOD !== '') {
        this.client.DOD.split('').forEach(function (item) {
          if (/^\d+$/.test(item)) {
            all.push('Deklaracje roczne');
          } else if (adds.hasOwnProperty(item)) {
            all.push(adds[item].label);
          }
        });
      }
      if (this.client && this.client.MDS !== null && this.client.MDS !== '') {
        this.client.MDS.split('').forEach(function (item) {
          if (item === 'P') {
            if (that.client.P_level === 3) {
              all.push('Płace i ZUS: bez limitu osób');
            } else if (that.client.P_level === 2) {
              all.push('Płace i ZUS: do 20 osób');
            } else if (that.client.P_level === 1) {
              all.push('Płace i ZUS: do 3 osób');
            } else {
              all.push('Płace i ZUS');
            }
          } else if (
            modules.hasOwnProperty(item) &&
            item !== 'P' &&
            item !== 'B'
          ) {
            all.push(modules[item].label);
          }
        });
      }

      return [...new Set(all)];
    },
  },
  methods: {
    getPrice() {
      axios
        .get(
          '/api/getNewYearOsPrice/' +
            this.programFormatMark +
            '/' +
            this.licence
        )
        .then(({ data }) => {
          this.price = data;
        })
        .catch((error) => {
          this.error =
            'Nie udało się obliczyć ceny. Aby uzyskać informacje skontaktuj się z BOK.';
        });
    },
  },
};
</script>

<style scoped></style>
